var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4v42h32V20H24a4 4 0 0 1-4-4V4Zm13.126 12L24 6.477V16h9.126ZM0 4a4 4 0 0 1 4-4h17.626a4 4 0 0 1 2.888 1.232l14.374 14.999A4 4 0 0 1 40 18.998V46a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
    fill: "currentColor"
  })));
};
export { SvgFile as ReactComponent };
export default __webpack_public_path__ + "12aaf3be39a92a26609d0ce99fb498f1.svg";